import { create } from "zustand";
import { IStorageStore, storageStoreDefaults } from "./storage.interfaces";

/// Not using the custom create fun on purpose so its not cleared on store reset...
export const useStorageStore = create<IStorageStore>()((set) => ({
  ...storageStoreDefaults,
  setHasHydrated: (state) => {
    set({ hasHydrated: state });
  },
}));
